import twicpicsAdapter from "./twicpics";
import cloudinaryAdapter from "./cloudinary";
import frontCommerceAdapter from "./front-commerce";
import akamaiAdapter from "./akamai";

/** @typedef {InstanceType<import("../ImageAdapter")['default']>} ImageAdapter */

class ImageAdaptersRegistry {
  /**
   * @type {Map<string, ImageAdapter>}
   * @private
   */
  adapters = new Map([
    [twicpicsAdapter.name, twicpicsAdapter],
    [cloudinaryAdapter.name, cloudinaryAdapter],
    [akamaiAdapter.name, akamaiAdapter],
  ]);

  /**
   * @param {ImageAdapter} adapter
   */
  register(adapter) {
    if (!this.adapters.has(adapter.name)) {
      this.adapters.set(adapter.name, adapter);
    }
  }

  /**
   *
   * @private
   * @param {string} src
   * @returns {ImageAdapter}
   */
  getAdapterForSrc(src) {
    const adapter = Array.from(this.adapters.values()).find((adapter) =>
      adapter.supportSrc(src)
    );

    return adapter || frontCommerceAdapter;
  }

  /**
   * @type {import("../makeImageSrc").makeImageSrc}
   */
  makeImageSrc(src, format, size, bg, extension, cover, baseUrl, focalPoint) {
    const imageAdapter = this.getAdapterForSrc(src);
    if (imageAdapter.supportSrc(src)) {
      return imageAdapter.makeImageSrc(
        src,
        format,
        size,
        bg,
        extension,
        cover,
        baseUrl,
        focalPoint
      );
    }

    return src;
  }

  /**
   * @param {string} src
   * @returns {string | null}
   */
  getDefaultExtension(src) {
    const imageAdapter = this.getAdapterForSrc(src);
    return imageAdapter.getDefaultExtension();
  }

  /**
   * @param {string} src
   * @param {boolean} transparent
   * @returns {string[] | [null]}
   */
  getSupportedExtensions(src, transparent = false) {
    const imageAdapter = this.getAdapterForSrc(src);
    const formats = imageAdapter.getSupportedExtensions(transparent);
    return Array.isArray(formats) ? formats : [formats];
  }
}

export default new ImageAdaptersRegistry();
